





































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Deal } from '@/types/Deal'
import { DiscountType } from '@/utils/enums'
import dealModule from '@/store/deal'

@Component({
  name: 'DealItem'
})
export default class Dealitem extends Vue {
  @Prop() readonly currentDeal!: Deal
  private discounttype = DiscountType
  private couponPrice = 0
  private retailPrice = 0

  private get isBookmark(): boolean {
    if (!dealModule.bookmarks) {
      return false
    }
    return dealModule.bookmarks
      .map(el => el.deal._id)
      .includes(this.currentDeal._id)
  }

  private get formattedCouponPrice() {
    return this.couponPrice.toFixed(2)
  }

  private get formattedRetailPrice() {
    return this.retailPrice.toFixed(2)
  }

  private get formattedOldPrice() {
    return this.currentDeal.discount.oldPrice.toFixed(2)
  }

  private get formattedNewPrice() {
    return this.currentDeal.discount.newPrice.toFixed(2)
  }

  private get formattedRelief() {
    return this.currentDeal.discount.relief.toFixed(2)
  }

  private async handleBookmark(): Promise<void> {
    if (this.isBookmark) {
      await dealModule.deleteBookmark(this.currentDeal)
    } else {
      await dealModule.createBookmark(this.currentDeal)
    }
    dealModule.fetchBookmarks()
  }

  private async created(): Promise<void> {
    this.couponPrice = await dealModule.getActiveCouponPrice(this.currentDeal)
    this.retailPrice = await dealModule.getActiveRetailPrice(this.currentDeal)
    if (!dealModule.bookmarks) {
      //await dealModule.fetchBookmarks()
    }
  }
}
